import { IonContent, IonPage,IonRow } from '@ionic/react';
import WaveTabsFriend from '../components/WaveTabsFriend';
import PageTitle from '../components/PageTitle';
import AddChallenge from 'components/AddChallenge';
import ChallengelistCard from 'components/ChallengelistCard';
import { RouteComponentProps } from 'react-router';
import { Challenges } from 'services/api';
import useAuth from 'hooks/useAuth';
import { ReactNode, useEffect, useState,useContext } from 'react';
import CenteredSpinner from 'components/CenteredSpinner';
import { generateRandomString, truncate } from "../services/util";
import { FilterContext } from "../State/FilterContext";
import AddTeamChallenge from 'components/AddTeamChallenge';
import TeamChallengelistCard from 'components/TeamChallengelistCard';

  const CreateTeamChallengePage: React.FC<RouteComponentProps> = (id:any) => {
	const { token } = useAuth();
	const [eventData, setUserData] = useState<ReactNode[]>();
	const [isLoading, setIsLoading] = useState<boolean>(true);


	const eventList = async () => {
			let response: any = [];
			let ChallengesList: any = [];
			let getData: any = [];
			let result: any = [];
			try {
				response = await Challenges.mymatches(token ?? "");
				if(response.success==false){
					ChallengesList = response.payload.map((item: any) => (
						<TeamChallengelistCard user={item} type="" key={generateRandomString()} />
					));
				}
				else{
					ChallengesList = (
						<IonRow className="ion-justify-content-center">
							<h1>No Team Matches Found.</h1>
						</IonRow>
					);
				}
				setUserData(ChallengesList);
			} catch (error) {
				console.log(error);
				setUserData([]);
			}
			return ChallengesList;	
		}

 
	
	useEffect(() => {
		eventList();
		setTimeout(() => {setIsLoading(false)}, 1000);
	}, [token]);

	const challenge_id = id.match.params.id;
	return (

		<IonPage>
			<IonContent fullscreen>
				<WaveTabsFriend
					leftTitle="Create"
					rightTitle="My Team Challenges"
					leftComponent={<AddTeamChallenge id={challenge_id}/>}
					rightComponent = {(isLoading==true) ? <CenteredSpinner/> : eventData}
					color='accent-two'
					leftRoute='addteamchallenge'
					rightRoute='myteamchallenge'
				>
					<PageTitle color="main">Team Challenge</PageTitle>
				</WaveTabsFriend>
			</IonContent>
		</IonPage>

	);
}
export default CreateTeamChallengePage;